import { frontendURL } from '../../../helper/URLHelper';

const TelephonyModule = () => import('./TelephonyModule.vue');
const TelephonyDashboard = () => import('./TelephonyDashboard.vue');
const TelephonyQueues = () => import('./TelephonyQueues.vue');
const TelephonyIvrs = () => import('./TelephonyIvrs.vue');
const TelephonyIvrEditor = () => import('./TelephonyIvrEditor.vue');
const TelephonyReports = () => import('./TelephonyReports.vue');
const TelephonySettings = () => import('./TelephonySettings.vue');

export const telephonyRoutes = [
  {
    path: frontendURL('accounts/:accountId/telephony'),
    component: TelephonyModule,
    children: [
      {
        path: '',
        redirect: to => ({
          name: 'telephony_dashboard',
          params: to.params,
        }),
      },
      {
        path: 'dashboard',
        name: 'telephony_dashboard',
        meta: { permissions: ['administrator', 'agent', 'supervisor'] },
        component: TelephonyDashboard,
      },
      {
        path: 'queues',
        name: 'telephony_queues',
        meta: { permissions: ['administrator'] },
        component: TelephonyQueues,
      },
      {
        path: 'ivrs',
        name: 'telephony_ivrs',
        meta: { permissions: ['administrator'] },
        component: TelephonyIvrs,
      },
      {
        path: 'ivrs/:ivrId/edit',
        name: 'telephony_ivr_editor',
        meta: { permissions: ['administrator'] },
        component: TelephonyIvrEditor,
      },
      {
        path: 'reports',
        name: 'telephony_reports',
        meta: { permissions: ['administrator', 'supervisor'] },
        component: TelephonyReports,
      },
      {
        path: 'settings',
        name: 'telephony_settings',
        meta: { permissions: ['administrator'] },
        component: TelephonySettings,
      },
    ],
  },
];
